import { Box, Heading } from '@chakra-ui/layout'
import { Button, useToast } from '@chakra-ui/react'
import { FileGenerator } from 'components/molecules/FileGenerator'
import { useAuthContext } from 'contexts/auth'
import { useInstitutionsContext } from 'contexts/institutions'
import { useGenerateFiles } from 'hooks/useGenerateFIles'
import { DocumentTypes } from 'pages/Report/types'
import { GlobalFilter } from 'pages/components/GlobalFilter'
import { useRef, useState } from 'react'
import {
    generateDashboardClosureReportPDF,
    getFilesClosureReports
} from 'services/report'
import { generateFile } from 'utils/blob'
import formatter from 'utils/formatter'
import ModeDashboard from './components/ModeDashboard'
import { ModeTable } from './components/ModeTable'
import { formFilter } from './form'
import { filterSchema } from './schema'
import { ClosureFilterDTO, TModes } from './types'
const { getImageBase64Dashboards } = useGenerateFiles()

export const Closure = () => {
    const toast = useToast()
    const [filter, setFilter] = useState<ClosureFilterDTO>(
        {} as ClosureFilterDTO
    )
    const { isBackoffice } = useAuthContext()
    const [loading, setLoading] = useState(false)
    const { currentInstitution, currentAgent } = useInstitutionsContext()
    const [currentMode, setCurrentMode] = useState<TModes>('table')
    const refModeTable = useRef<any>(null)
    const [loadingFile, setLoadingFile] = useState<boolean>(false)

    const formatFilter = (filter: ClosureFilterDTO) => {
        let formatFilter = {}
        Object.keys(filter).forEach(key => {
            formatFilter = {
                ...formatFilter,
                [key]: filter[key as keyof ClosureFilterDTO] ?? '',
                periodoInicial: filter?.periodoInicial
                    ? formatter.timeConverter(filter?.periodoInicial)
                    : '',
                periodoFinal: filter?.periodoFinal
                    ? formatter.timeConverter(filter?.periodoFinal)
                    : ''
            }
        })

        return formatFilter
    }

    const filterPayload = formatFilter(filter) as ClosureFilterDTO

    const callAPI = (type: DocumentTypes) => {
        downloadFiles(type)
    }

    const setCurrentFilters = (value: any) => {
        refModeTable?.current?.resetPage && refModeTable.current.resetPage()
        setFilter(value)
    }

    const downloadFiles = async (type: DocumentTypes) => {
        try {
            setLoadingFile(true)
            if (!modeTable) {
                const imageBase64 = await getImageBase64Dashboards(
                    'finance-report'
                )

                if (imageBase64) {
                    const response = await generateDashboardClosureReportPDF(
                        filterPayload as any,
                        imageBase64,
                        currentInstitution?.id,
                        currentAgent?.cnpj,
                        isBackoffice
                    )

                    generateFile('PDF', response)

                    toast({
                        title: 'Arquivo gerado com sucesso!',
                        description: `O arquivo ${type} foi gerado conforme os filtros selecionados. Verifique sua pasta de downloads para acessá-lo.`,
                        position: 'bottom-left',
                        status: 'success',
                        isClosable: true
                    })

                    return
                }
                return
            }

            const response = await getFilesClosureReports(
                {
                    ...filterPayload,
                    tipo: type,
                    cnpjAgente: currentAgent?.cnpj ?? ''
                },
                currentInstitution?.id
            )

            generateFile(type, response)

            toast({
                title: 'Arquivo gerado com sucesso!',
                description: `O arquivo ${type} foi gerado conforme os filtros selecionados. Verifique sua pasta de downloads para acessá-lo.`,
                position: 'bottom-left',
                status: 'success',
                isClosable: true
            })
        } catch (error) {
            toast({
                title: 'Sentimos muito!',
                description: 'Ocorreu algum erro, tente novamente mais tarde.',
                position: 'bottom-left',
                status: 'error',
                isClosable: true
            })
        } finally {
            setLoadingFile(false)
        }
    }

    const modeTable = currentMode === 'table'

    const labelMode = !modeTable ? 'Modo Tabela' : 'Modo Dashboard'
    const onChangeMode = () => {
        const newMode = modeTable ? 'dashboard' : 'table'
        setCurrentMode(newMode)
    }

    return (
        <>
            <Box
                display="flex"
                justifyContent="space-between"
                margin="24px 0"
                gap="8px"
            >
                <Heading size="md">Gestão Fechamento</Heading>
                <Box gap={'4'} flex={'row'}>
                    <Button
                        marginRight={'8px'}
                        colorScheme="primary"
                        type="submit"
                        onClick={onChangeMode}
                    >
                        {labelMode}
                    </Button>
                    <FileGenerator
                        callAPI={callAPI}
                        onlyPDF={!modeTable}
                        loading={loadingFile}
                    />
                </Box>
            </Box>

            <GlobalFilter
                schema={filterSchema}
                form={formFilter}
                actionFilter={setCurrentFilters}
                loadingFilter={loading}
                title="Filtrar Relatório(s)"
            />

            {modeTable && (
                <ModeTable filter={filterPayload} ref={refModeTable} />
            )}
            {!modeTable && (
                <ModeDashboard
                    filter={filterPayload}
                    idDashboard="finance-report"
                />
            )}
        </>
    )
}
